import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { AuthGuard } from './core/guards/auth.guard';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { LayoutComponent } from './layouts/layout.component';


const routes: Routes = [
  { path: 'account', component: AuthLayoutComponent,  loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  { path: 'external', component: LayoutComponent,  loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  { path: '',  component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
